



























































































































import BaseComponent from '@/core/base.component';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AnalysisTabService from '@/services/analysis/analysis-tab.service';
import { AnalysisTabListDto } from '@/dto';
import { ReverseQueryParamMapper } from '@/core';

@Component({
  name: 'AnalysisSummary',
})
export default class AnalysisSummary extends BaseComponent {
  @Prop() bdongCode!: string;
  private analysisTabSearchDto = new AnalysisTabListDto();
  private summary = {};
  private dataLoading = true;
  private dataLoadingCategory = true;
  private categories = [];
  private recomeendCategory = [];
  private parmas = null;
  @Watch('bdongCode')
  bdongCodeChanged() {
    this.analysisTabSearchDto.bdongCode = this.bdongCode;
    this.findAnalysisSummary();
  }

  recommendCategoryBgColor(idx) {
    if (idx === 0) return 'bg-primary';
    if (idx === 1) return 'bg-warning';
    if (idx === 2) return 'bg-success';
  }

  async findSummary() {
    this.summary = {};
    this.dataLoading = true;
    await AnalysisTabService.findSummary(this.analysisTabSearchDto).subscribe(
      res => {
        // console.log('findSummary res', res);
        this.dataLoading = false;
        this.summary = res.data;
      },
    );
  }

  async findCategoryRatio() {
    this.dataLoadingCategory = true;
    await AnalysisTabService.findCategoryRatio(
      this.analysisTabSearchDto,
    ).subscribe(res => {
      if (res) {
        // console.log('findCategoryRatio res', res);
        this.dataLoadingCategory = false;
        this.categories = res.data;
        this.recomeendCategory = this.categories.slice(0, 3);
      } else {
        console.log('findCategoryRatio failed');
      }
    });
  }

  async findAnalysisSummary() {
    await this.findCategoryRatio();
    await this.findSummary();
  }
  // created() {
  //   setTimeout(() => this.findAnalysisSummary(), 2000);
  // }
  created() {
    this.analysisTabSearchDto.bdongCode = this.bdongCode;
    setTimeout(() => this.findAnalysisSummary(), 1000);
  }
}
